import React from 'react';
import { createRoot } from 'react-dom/client';

import Web from './src/index.web';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Web />
  </React.StrictMode>,
);
